import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import Utils from '../../../utils';
import { Link } from 'react-router';
import { DriveListState } from '../../DriveItemList/reducer';
import { fetchDriveItem } from '../../DriveItemList/actions';
import { BreadcrumbThread } from './styles';
import RoutesUtils from '../../../utils/routes';
import { DriveItemListOrigin } from '../../DriveItemListPage/constants';
import hashHistory from 'react-router/lib/hashHistory';

export interface BreadcrumbsProps {
	dispatch: Dispatch<StoreState>;
	driveList: DriveListState;
	currentFolderId: number;
	galleryId: number;
}

export interface BreadcrumbsState {
	folderTree: FolderTreeItem[];
}

interface FolderTreeItem {
	id: number;
	label: string;
}

class Breadcrumbs extends React.Component<BreadcrumbsProps, BreadcrumbsState> {

	constructor(props: BreadcrumbsProps) {
		super(props);
		this.state = { folderTree: [] };
	}

	componentDidMount() {
		this.computeFolderTree(this.props);
	}

	componentWillReceiveProps(nextProps: BreadcrumbsProps) {
		this.computeFolderTree(nextProps);
	}

	render() {
		const { folderTree } = this.state;
		const { galleryId } = this.props;
		const isLoaded = folderTree.length > 0 && folderTree[0].id === galleryId;

		return (
			<BreadcrumbThread>
				{ !isLoaded
					? <div />
					: this.renderFolderTree()
				}
			</BreadcrumbThread>
		);
	}

	renderFolderTree() {
		const { folderTree } = this.state;
		if (folderTree.length > 3) {
			const removedItems = folderTree.length - 3;
			const antepenultimateId = folderTree[folderTree.length - 3].id;
			folderTree.splice(1, removedItems, { id: antepenultimateId, label: '...'});

			return folderTree.map(this.mapFolderTreeToElements.bind(this));
		}
		return folderTree.map(this.mapFolderTreeToElements.bind(this));
	}

	mapFolderTreeToElements(item: FolderTreeItem, index: number) {
		const { currentFolderId, galleryId } = this.props;

		if (item.id !== currentFolderId) {
			const path = `${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, galleryId === item.id ? '' : item.id.toString())}`;
			return [
				(
					<Link
						to={`${path}${hashHistory.getCurrentLocation().search}`}
						key={item.id}
					>
						{item.label}
					</Link>
				),
				Utils.getSvgIcon('iconset_forth', { key: `chevron-${item.id}` })
			];
		}

		return <span key={item.id}>{item.label}</span>;
	}

	computeFolderTree(props: BreadcrumbsProps): void {
		const { currentFolderId } = props;
		const folderTree = this.getFolderTree(currentFolderId, props);

		this.setState({ folderTree });
	}

	getFolderTree(folderId: number, props: BreadcrumbsProps): FolderTreeItem[] {
		const { galleryId, driveList, dispatch } = props;
		const { driveItems } = driveList;
		const folder = driveItems[folderId];

		if (folder) {
			const { label, id, parent } = folder;

			if (label && id) {
				const isRootGallery = folderId === galleryId;
				const parentTree = parent && !isRootGallery ? this.getFolderTree(parent, props) : [];

				return [...parentTree, { label, id }];
			}
		} else {
			dispatch(fetchDriveItem(folderId));
		}

		return [];
	}
}

const mapStateToProps = (state: StoreState) => {
	const { driveList } = state;
	return { driveList };
};

export default connect(mapStateToProps)(Breadcrumbs);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/Breadcrumbs/index.tsx